import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAvatarPlaceholder = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 240 240",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_643_39198)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 240,
			height: 240,
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M220 240C220 295.228 175.228 340 120 340C64.7715 340 20 295.228 20 240H220ZM240 240H220C220 184.772 175.228 140 120 140C64.7715 140 20 184.772 20 240H0V0H240V240ZM120 40C92.3858 40 70 62.3858 70 90C70 117.614 92.3858 140 120 140C147.614 140 170 117.614 170 90C170 62.3858 147.614 40 120 40Z",
			fill: "#E4E4E7"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_643_39198",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 240,
			height: 240,
			fill: "white"
		})
	}) })]
});
export default SvgAvatarPlaceholder;
